// extracted by mini-css-extract-plugin
module.exports = {"mappingDropdown":"styles_mappingDropdown__8dPTq","newTag":"styles_newTag__7pxSE","dropdownElement":"styles_dropdownElement__fVDmJ","editSpace":"styles_editSpace__uP2Tf"};